import isV5ChartDef from '../../../../../../types/visTypeCheckers/isV5ChartDef';
import isSingleMetricDateMatrix from '../../../../../../types/visTypeCheckers/isSingleMetricDateMatrix';
import isRankingMatrix from '../../../../../../types/visTypeCheckers/isRankingMatrix';
import isGauge from '../../../../../../types/visTypeCheckers/isGauge';
import isPaceMatrix from '../../../../../../types/visTypeCheckers/isPaceMatrix';

const replaceMetricInChart = (
  findMetricId: string,
  replaceMetricId: string,
  def: VisualisationDefinition,
) => {
  const newDef = structuredClone(def);
  if (isV5ChartDef(newDef)) {
    newDef.series = newDef.series.map((s) => {
      return {
        ...s,
        metricId: s.metricId === findMetricId ? replaceMetricId : s.metricId,
      };
    });
  } else if (
    isSingleMetricDateMatrix(newDef) ||
    isGauge(newDef) ||
    isPaceMatrix(newDef)
  ) {
    if (newDef.metricId === findMetricId) {
      newDef.metricId = replaceMetricId;
    }
  } else if (isRankingMatrix(newDef)) {
    newDef.metrics = newDef.metrics.map((m) => {
      return {
        ...m,
        metricId: m.metricId === findMetricId ? replaceMetricId : m.metricId,
      };
    });
  }
  return newDef;
};

export default replaceMetricInChart;
